import { Link } from "react-router-dom";
import { openInNewTab } from "../../utils/openInNewTab";

export function GetStartedLink({ item }) {
  const isExternal = item.external || item.link.startsWith("http");
  const Icon = item.icon;

  const baseClasses =
    "group rounded-2xl border border-gray-200 bg-white px-6 py-5 transition-colors duration-200 hover:border-[#0052FF]/40 cursor-pointer";

  const content = (
    <div className="flex flex-col gap-4">
      {/* Icon */}
      <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#0052FF]/10 text-[#0052FF] transition-colors group-hover:bg-[#0052FF]/15">
        <Icon className="w-6 h-6" />
      </div>

      {/* Text */}
      <div className="space-y-1">
        <h3 className="text-gray-900 font-semibold text-base leading-tight">
          {item.title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed">
          {item.description}
        </p>
      </div>

      {/* Action */}
      <div className="pt-2">
        <span className="inline-flex items-center text-sm font-medium text-[#0052FF]">
          Get started
          <span className="ml-1 transition-transform group-hover:translate-x-0.5">
            →
          </span>
        </span>
      </div>
    </div>
  );

  const handleClick = (e) => {
    e.preventDefault();
    openInNewTab(item.link);
  };

  return isExternal ? (
    <div onClick={handleClick} className={baseClasses}>
      {content}
    </div>
  ) : (
    <Link to={item.link} className={baseClasses}>
      {content}
    </Link>
  );
}